/**
 * RIDDOR 2013 categories used by the accident form and the accident PDF.
 * Single source of truth so the PDF always shows exactly what was ticked.
 */
export interface RiddorItem { key: string; label: string; hint?: string; }
export const RIDDOR_ITEMS: RiddorItem[] = [
  { key: 'fatality',     label: 'Someone died' },
  { key: 'broken_bone',  label: 'Broken bone — not fingers, toes or thumb', hint: 'Arm, leg, ribs, back, jaw, etc.' },
  { key: 'amputation',   label: 'Amputation — anything taken off' },
  { key: 'sight_loss',   label: 'Permanent sight loss' },
  { key: 'crush_head',   label: 'Crush injury to head or torso' },
  { key: 'big_burn',     label: 'Burn bigger than a hand', hint: 'Roughly 10% of the body or more' },
  { key: 'scalping',     label: 'Scalping (skin torn off head)' },
  { key: 'unconscious',  label: 'Knocked out or unconscious' },
  { key: 'over7day',     label: 'Off normal work for 7+ days', hint: 'Any employee who can\'t do their normal job for more than a week' },
  { key: 'haa_diagnosis', label: 'Doctor diagnosed work disease', hint: 'HAVS, dermatitis, asthma, carpal tunnel, work-related cancer' },
  { key: 'scaffold_collapse', label: 'Scaffold collapse 5m+' },
  { key: 'gas_chemical_release', label: 'Gas / chemical release that could hurt people' },
  { key: 'electrical_fire', label: 'Electrical incident causing fire or explosion' },
];

/** Labels for every key ever stored in forms.riddor_flags (incl. the
 *  pre-Aug-2026 short list) so old reports still render correctly. */
export const RIDDOR_LABELS: Record<string, string> = {
  ...Object.fromEntries(RIDDOR_ITEMS.map((r) => [r.key, r.label])),
  specified: 'Specified injury',
  occ_disease: 'Occupational disease',
  dangerous: 'Dangerous occurrence',
};
